<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>对账流水</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form
      :inline="true"
      :model="formInline"
      label-position="right"
      label-width="120px"
      class="searchBar"
    >
      <el-row>
        <el-col :span="8">
          <el-form-item label="日期">
            <el-date-picker
              style="width: 190px !important"
              size="small"
              v-model="formInline.createDate"
              type="date"
              value-format="yyyy-MM-dd hh:mm:ss"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item>
            <el-button
              size="small"
              type="primary"
              icon="el-icon-search"
              @click="handleSearch"
              >搜索</el-button
            >
            <el-button
              size="small"
              type="info"
              icon="el-icon-delete"
              @click="handleReset"
              >清空</el-button
            >
            <el-button
              size="small"
              icon="el-icon-plus"
              v-hasPerm="btn_perm_type.ticket.in.add"
              @click="handleEdit(null,null)"
              >新增</el-button
            >
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!--列表-->
    <el-table
      size="small"
      :data="userData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column
        align="center"
        prop="checkDate"
        label="日期"
        width="100"
        show-overflow-tooltip
      >
      </el-table-column>
      
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        width="100"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
      align="center"
        prop="receivables"
        label="应收款"
        width="100"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="payable"
        label="应付款"
        width="100"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="ticketCoins"
        label="当日购票资金成本"
        width="100"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="bank1"
        label="华之瑞修农"
        width="100"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
       <el-table-column
        prop="bank2"
        label="华之瑞山西"
        width="100"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
       <el-table-column
        prop="bank3"
        label="现金"
        width="100"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
       <el-table-column
        prop="bank4"
        label="华之瑞亿联"
        width="100"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
       <el-table-column
        prop="bank5"
        label="锦乐飞沁阳0121+庄严亿联"
        width="100"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
       <el-table-column
        prop="bank6"
        label="庞钱民生"
        width="100"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
       <el-table-column
        prop="bank7"
        label="王建信用社"
        width="100"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
       <el-table-column
        prop="bank8"
        label="少其山西2214"
        width="100"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
       <el-table-column
        prop="bank9"
        label="庄严山西2381"
        width="100"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
       <el-table-column
        prop="bank10"
        label="王威兴业"
        width="100"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="bank11"
        label="基本户"
        width="100"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="bank12"
        label="金飞益招商"
        width="100"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="bank13"
        label="少其亿联"
        width="100"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="bank14"
        label="麦丰亿联"
        width="100"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="bank15"
        label="乐共农商+金飞益博爱中行"
        width="100"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>

      <el-table-column
        prop="bank16"
        label="其他"
        width="100"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="total"
        label="合计"
        width="100"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      
      <el-table-column align="center" label="操作" width="390">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="handleEdit(scope.row)"
            >编辑</el-button>
          <el-button
            size="mini"
            type="success"
            @click="handleTransaction('充值:',1,scope.row.id)"
            >充值</el-button>
          <el-button
            size="mini"
            type="success"
            @click="handleTransaction('提现:',2,scope.row.id)"
            >提现</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleTransaction('卖票款:',3,scope.row.id)"
            >卖票款</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleTransaction('买票款:',4,scope.row.id)"
            >买票款</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination :pager="pager" @pager="handlePager"></Pagination>
    <EditForm
      :title="title"
      :visible.sync="editFormVisible"
      :edit-form="editForm"
      @confirm="handleEditForm"
    ></EditForm>
    <EditTransaction
      :title="title"
      :type = "type"
      :id = "id"
      :visible.sync="editTransactionVisible"
      :edit-form="editTransaction"
      @confirm="handleEditForm"
    ></EditTransaction>
  
  </div>
</template>

<script>
import { listReconcileStream, delTicket, delBatchTicket } from "@/api/ticket/ticket";
import Pagination from "@/components/pagination";
import EditForm from "./add-edit";
import EditTransaction from "./add-edit/transaction";
import { BTN_PERMS_TYPE } from "@/utils/permissions";

export default {
  data() {
    return {
      btn_perm_type: BTN_PERMS_TYPE,
      loading: false,
      editFormVisible: false,
      editFormDetailVisible: false,
      editTransactionVisible: false,
      title: "",
      id:0,
      type: 0,
      editForm: {},
      editTransaction: {},
      formInline: {},
      userData: [],
      pager: {
        currentPage: 1,
        pageSize: 10,
        total: 1,
      },
      batchVisible: false,
      batchVisibleBack: false,
      selectRows: [],
      faceCount: 0,
      allInValue: 0,
      faceAllValue: 0,
      allInDifferencePrice: 0,
      editData: [],
    };
  },
  components: {
    Pagination,
    EditForm,
    EditTransaction
  },
  created() {
    this.getData();
  },
  methods: {
    handleAddTicketConfirm() {
      this.getData();
    },
    getData() {
      this.selectRows = [];
      this.loading = true;
      console.info()
      if (!this.pager.currentPage) {
        this.pager.currentPage = 1
      }
      listReconcileStream(this.pager.currentPage, this.pager.pageSize, this.formInline)
        .then(
          ({
            pages,
          }) => {
            const { content, page, size, totalCount } = pages;
            this.userData = content;
            this.pager.currentPage = page;
            this.pager.pageSize = size;
            this.pager.total = totalCount;
          }
        )
        .catch(this.$message.error)
        .finally(() => {
          this.editTransaction = {};
          this.loading = false;
        });
    },
    handlePager(pager) {
      this.pager.currentPage = pager.currentPage;
      this.pager.pageSize = pager.pageSize;
      this.getData();
    },
    handleSearch() {
      this.getData();
    },
    handleReset() {
      this.formInline = {};
      this.getData();
    },
    
    handleEdit(row, readonly) {
      console.info(row)
      if (row) {
        this.title = "修改";
        this.editForm = row;
      } else {
        this.title = "新增";
        this.editForm = {};
      }
      if (readonly) {
        this.editFormDetailVisible = true;
      } else {
        this.editFormVisible = true;
      }
    },
    handleTransaction(title,type,id) {
      this.title = title;
      this.type = type;
      this.id = id;
      this.editTransaction = {};
     
      this.editTransactionVisible = true;
    },
    handleEditForm() {
      this.getData();
    },
  },
};
</script>

<style scoped>
.searchBar {
  margin-top: 20px;
}
.el-input {
  width: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/views/ticket/ticket-flow/index.vue